<template>
    <div class="text-block block-card card-border ">
        <v-expansion-panel expand :value="panel">
            <v-expansion-panel-content :lazy="true">
                <template v-slot:header >
                    <div class="block-card-title handle" >
                        <div class="title-icon">
                            <img src="../../../../assets/img/ic_gallery-sm.png" alt="">
                        </div>

                        <h4>Image</h4>
                    </div>
                </template>
                <div class="block-card-body">
                    <image-input :url="data.url" @onImageUpload="updateImageUrl"></image-input>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
    import common from "../../../../utils/common"
    import imageInput from './common-inner-blocks/image-uploader-dropzone'
    export default {
        name: "card-image-url",
        components: {
            imageInput
        },
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            },
            index: {
                type: Number,
                default: ()=> {
                    return 0
                }
            },
            blocksList: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data() {
            return {
                valid: true,
                panel: 1,
                common
            }
        },
        mounted() {

        },
        methods: {
            updateImageUrl(url) {
                this.data.url = url
            }
        },
        computed: {

        },
        watch: {

        }
    }
</script>

<style scoped>

</style>